import { render, staticRenderFns } from "./TransporterDetails.vue?vue&type=template&id=4a4a4fcc"
import script from "./TransporterDetails.vue?vue&type=script&lang=js"
export * from "./TransporterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports